<div class="blue full body">
  <app-navbar></app-navbar>

  <div class="main">
    <div class="struct-heading">
      <h1>RESET PASSWORD</h1>
    </div>
    <!-- <app-sqanimation></app-sqanimation> -->
    <div class="form">
      <!-- <h1 style="display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;"><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">RESET PASSWORD</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1> -->
      <form
        [formGroup]="firstFormGroup"
        style="border-radius: 1.5rem"
        class="main-form"
      >
        <br />
        <mat-form-field class="input-field" appearance="outline">
          <!-- <mat-label class="input-label">Team ID</mat-label> -->
          <input
            matInput
            placeholder="Email ID*"
            formControlName="teamid"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['teamid'].hasError('required')"
          >
            ID is required!
          </mat-error> </mat-form-field
        ><br />
        <!-- <mat-form-field   class="input-field">
              <mat-label class="input-label">Team Password</mat-label>
              <input matInput formControlName="password"  placeholder="Enter your password" [type]="hide ? 'password' : 'text'"  name="password">
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="firstFormGroup.controls['password'].hasError('required')">
                Password is required!
            </mat-error>
            </mat-form-field> -->
        <div class="butbut">
          <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
          <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
          <button class="green-button" mat-button (click)="submit()">
            Submit
          </button>
        </div>
      </form>
      <div class="foot">
        <div>
          <h5>
            <a style="color: black" [routerLink]="['/reg']"
              >New User? Register Now</a
            >
          </h5>
        </div>
        <div class="end">
          <h5>
            <a style="color: black" [routerLink]="['/login']"
              >Already Registered? Login Now</a
            >
          </h5>
        </div>
      </div>
    </div>
  </div>

  <div>
    <app-footer></app-footer>
  </div>
</div>
